import React from 'react';

import styles from './sidebarProfileWidgetStyles';

import CounterList from 'buyside/components/presentation/CounterList/counterList';
import RemainingAccess from 'buyside/components/presentation/RemainingAccess/remainingAccess';
import ProfileImage from 'buyside/components/presentation/ProfileImage/profileImage';
import Link from 'buyside/components/presentation/Link/link';
import FeaturedRank from 'buyside/components/presentation/FeaturedRank/featuredRank';

import { employerProfileUrl, profileUrl } from 'buyside/util/urlHelper';

const accessData = (currentUser, accessType) => ({
  type: 'product',
  isBlocked: currentUser[`${accessType}IsBlocked`],
  daysRemaining: currentUser[`${accessType}DaysLeft`]
});

const quotaData = (paladin, quotaType) => ({
  type: 'paladin',
  quota: `${paladin[`${quotaType}CurrentMonth`]}/${paladin[`${quotaType}Quota`]}`,
  percentRemaining: paladin[`${quotaType}Percent`],
  quotaDeadline: paladin.nextQuotaDeadline
});

const SidebarProfileWidget = ({ data }) => {
  const user = data.currentUser;
  const profile = data.currentUser.profile;

  let featuredRankEl;
  if (user.featuredRank) {
    featuredRankEl = <FeaturedRank featuredRank={user.featuredRank} withMarginTop />;
  }

  const counters = [
    { title: 'Ideas', count: user.publishedIdeasCount },
    { title: 'Following', count: user.activeFollowedUsersCount },
    { title: 'Followers', count: user.activeFollowersCount }
  ];

  //this should be refactored to reference the employer route which distinguishes betwen
  //employers that have fund profiles and those that don't

  if (window.hj && profile.latest_employer_id) {
    window.hj('tagRecording', [`employer_${profile.latest_employer_id}`]);
  }

  const { canWriteIdeas, currentEmployers } = user;

  return (
    <>
      <div className={styles.flex}>
        <div className={styles.profileImage}>
          <ProfileImage source={user.profileImageUrl} size={'small'} />
        </div>
        <div className={styles.profileAssociation}>
          {user.isAllocator ? (
            <strong>{user.displayName}</strong>
          ) : (
            <Link to={profileUrl(profile.id)}>
              <strong>{user.displayName}</strong>
            </Link>
          )}
        </div>
      </div>
      <div className={styles.currentEmployers}>
        {currentEmployers.map((currentEmployer, idx) => (
          <Link key={`sidebar-employer-${idx}`} to={employerProfileUrl(currentEmployer.id)}>
            {currentEmployer.name}
          </Link>
        ))}
      </div>
      <div className={styles.sidebarProfileCounters}>
        <CounterList counters={counters} type="small" />
      </div>
      <div className={styles.sidebarProfileAccess}>
        <RemainingAccess
          isPaladin={user.isPaladin}
          canWriteIdeas={canWriteIdeas}
          accessData={accessType => accessData(data.currentUser, accessType)}
          quotaData={quotaType => quotaData(data.currentUser.paladin, quotaType)}
          hasPollAnswerQuota={
            data.currentUser.paladin && data.currentUser.paladin.hasPollAnswerQuota
          }
        />
      </div>
      {featuredRankEl}
      {user.primaryContact && (
        <div className={styles.primaryContactContainer}>
          <div className={styles.contactHeader}>Your SumZero Representative:</div>
          <div className={styles.contactName}>{user.primaryContact.displayName}</div>
          <a href={`mailto:${user.primaryContact.email}`}>
            <div className={styles.contactEmail}>{user.primaryContact.email}</div>
          </a>
        </div>
      )}
    </>
  );
};

export default SidebarProfileWidget;
